import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  EventEmitter,
  Output
} from "@angular/core";
import { ProfiliService } from "@app/shared/services/profili.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { VisibilitaRequestVO } from "@app/shared/vo/visibilita-requestVO";
import { DipendenteVO } from "@app/shared/vo/dipendenteVO";
import { ControlContainer, FormArray, FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-modale-componenti-collegio",
  templateUrl: "./modale-componenti-collegio.component.html",
  providers: [ProfiliService]
})
export class ModaleComponentiCollegioComponent implements OnInit {



  messages = {
    emptyMessage: "Nessun risultato",
    totalMessage: "in totale"
  };


  @Output()
  emettiListaComponenti: EventEmitter<DipendenteVO[]> = new EventEmitter<DipendenteVO[]>();


  listaComponenti: DipendenteVO[];

  public modalRef: BsModalRef;

  utentiList: VisibilitaRequestVO[] = [];

  utentiListFinale: VisibilitaRequestVO[] = [];



  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true
  };

  @ViewChild("templateModaleCollegio", { static: false })
  public collegioModal: TemplateRef<any>;

  collegioRevisoriFormArray: FormArray;

  parentForm: any;


  constructor(
    private modalService: BsModalService,
    private controlContainer: ControlContainer
  ) {

  }

  ngOnInit() {
    this.parentForm = this.controlContainer.control;
    this.collegioRevisoriFormArray = this.parentForm.get("collegioRevisori") as FormArray;
  }

  aggiungiComponente() {
    if (this.collegioRevisoriFormArray.valid) {
      this.collegioRevisoriFormArray.insert(this.collegioRevisoriFormArray.length, new FormGroup({
        nome: new FormControl("", Validators.required),
        cognome: new FormControl("", Validators.required),
        codiceFiscale: new FormControl("", [Validators.required, Validators.pattern("[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$")]),
        email: new FormControl("", [Validators.email, Validators.required])
      }));
    }
  }

  rimuoviComponente(i: number) {
    this.collegioRevisoriFormArray.removeAt(i);
  }


  public openModal(
  ) {

    this.modalRef = this.modalService.show(this.collegioModal, this.config);

    //  }
  }






}
